import { render, staticRenderFns } from "./cover-upload.vue?vue&type=template&id=7426aab6&"
import script from "./cover-upload.vue?vue&type=script&lang=js&"
export * from "./cover-upload.vue?vue&type=script&lang=js&"
import style0 from "./cover-upload.vue?vue&type=style&index=0&id=7426aab6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports